/* eslint-disable i18next/no-literal-string -- . */
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/base/tabs';
import { ApproveCoupon } from './approve-coupon';
import { ImpersonationForm } from './impersonate';
import { ManagePayouts } from './payouts';
import { Promoters } from './promoters';
import { UpdateUserData } from './update-user-data';

export function Admin(): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      <Tabs defaultValue="managePayouts">
        <div className="mx-4">
          <TabsList>
            <TabsTrigger value="managePayouts">Manage Payouts</TabsTrigger>
            <TabsTrigger value="approveCoupon">Approve Coupons</TabsTrigger>
            <TabsTrigger value="promoters">Promoters</TabsTrigger>
            <TabsTrigger value="updateUser">Update User</TabsTrigger>
            <TabsTrigger value="impersonation">Impersonate</TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value="managePayouts">
          <ManagePayouts />
        </TabsContent>
        <TabsContent value="approveCoupon">
          <ApproveCoupon />
        </TabsContent>

        <TabsContent value="promoters">
          <Promoters />
        </TabsContent>

        <TabsContent value="updateUser">
          <UpdateUserData />
        </TabsContent>

        <TabsContent value="impersonation">
          <ImpersonationForm />
        </TabsContent>
      </Tabs>
    </div>
  );
}
